import us from "./us"
export default{
    US: us
}